// Module
var code = "<google-calendar></google-calendar>`";
// Exports
module.exports = code;